const DEFAULT_STATE = {};

export default function(state, action) {
    if (!state) {
        state = {...DEFAULT_STATE};
    }

    switch (action.type) {
        case 'EVENTS_UPDATE_USER_EVENT':
            state = {...action.userEvent};
            break;
    }

    return state;
}
